import styled, { StyledComponent } from 'styled-components';

export const MarginWrapper = styled.div`
  flex: 1;

  .group-last {
    padding-left: 26px;
    margin-bottom: 16px;
  }
  .check-item {
    display: flex;
    > div:first-child {
      width: 122px;
    }
    > div:nth-child(2) {
      color: rgba(0, 0, 0, 0.45);
      margin-left: 8px;
    }
  }
`;

export const SelectInView: StyledComponent<'div', any> = styled.div`
  padding: 6px 8px;
  justify-content: space-between;
  align-items: center;
  border-radius: 4px;
  background-color: #f5f5f5;
  width: fit-content;
  display: inline-flex;
  margin: 0 6px;
  min-height: 20px;
`;
